import LoadDispatch from "./LoadDispatch";

export default LoadDispatch;